import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import Papa from "papaparse";
import "leaflet/dist/leaflet.css";

const makeIcon = (file) =>
  new L.Icon({
    iconUrl: `/${file}`, // file should exist in public/
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });

const icons = {
  AGH: makeIcon("agh.png"),
  PHC: makeIcon("phc.png"),
  CHC: makeIcon("chc.png"),
  DGH: makeIcon("dgh.png"),
  GGH: makeIcon("ggh.png"),
  MCH: makeIcon("mch.png"),
  PRIVATE: makeIcon("private.png"),
};

const allHospitalIcon = makeIcon("hospital.png");

function App() {
  const [hospitals, setHospitals] = useState([]);
  const [filter, setFilter] = useState("All");
  const [selectedHospital, setSelectedHospital] = useState(null);

  useEffect(() => {
    Papa.parse("/hospitals.csv", {
      download: true,
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        const knownTypes = ["AGH", "PHC", "CHC", "DGH", "GGH", "MCH"];

        const cleaned = result.data
          .map((row) => {
            const lat = parseFloat(row.lat || row.latitude);
            const lng = parseFloat(row.lng || row.longitude);
            const name = row.name || row.hospital || "Unknown Hospital";

            let type = "PRIVATE";
            const upperName = name.toUpperCase();
            for (let t of knownTypes) {
              if (upperName.includes(t)) {
                type = t;
                break;
              }
            }

            if (!isNaN(lat) && !isNaN(lng)) {
              return {
                name,
                lat,
                lng,
                type,
                address: row.address || "No address available",
                contact: row.contact || "No contact info",
                capacity: row.capacity || "Unknown capacity",
              };
            }
            return null;
          })
          .filter(Boolean);

        setHospitals(cleaned);
      },
    });
  }, []);

  const filteredHospitals =
    filter === "All"
      ? hospitals
      : hospitals.filter((h) => h.type === filter);

  return (
    <div style={{ position: "relative", height: "100vh", width: "100%" }}>
  
      <div
        style={{
          position: "absolute",
          top: 100,
          left: 10,
          zIndex: 1000,
          background: "white",
          padding: "6px",
          borderRadius: "6px",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
        }}
      >
        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="All">All Hospitals</option>
          <option value="AGH">AGH</option>
          <option value="PHC">PHC</option>
          <option value="CHC">CHC</option>
          <option value="DGH">DGH</option>
          <option value="GGH">GGH</option>
          <option value="MCH">MCH</option>
          <option value="PRIVATE">Private</option>
        </select>
      </div>

      {/* Map */}
      <MapContainer
        center={[20.5937, 78.9629]}
        zoom={5}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {filteredHospitals.map((hospital, i) => (
          <Marker
            key={i}
            position={[hospital.lat, hospital.lng]}
            icon={
              filter === "All"
                ? allHospitalIcon
                : icons[hospital.type] || icons.PRIVATE
            }
            eventHandlers={{
              mouseover: (e) => {
                e.target.openPopup();
                setSelectedHospital(hospital);
              },
              mouseout: (e) => {
                e.target.closePopup();
                setSelectedHospital(null);
              },
            }}
          >
            <Popup>
              <b>{hospital.name}</b>
              <br />
              Type: {hospital.type}
              <br />
              Lat: {hospital.lat}, Lng: {hospital.lng}
            </Popup>
          </Marker>
        ))}
      </MapContainer>

      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          height: "100%",
          width: selectedHospital ? "300px" : "0px",
          background: "#f8f9fa",
          borderLeft: selectedHospital ? "1px solid #ddd" : "none",
          padding: selectedHospital ? "16px" : "0px",
          overflowY: "auto",
          boxShadow: selectedHospital ? "-4px 0 8px rgba(0,0,0,0.2)" : "none",
          transition: "all 0.3s ease",
          transform: selectedHospital ? "translateX(0)" : "translateX(100%)",
          opacity: selectedHospital ? 1 : 0,
          pointerEvents: selectedHospital ? "auto" : "none",
          zIndex: 1000,
        }}
      >
        {selectedHospital && (
          <>
            <h2>{selectedHospital.name}</h2>
            <p><b>Type:</b> {selectedHospital.type}</p>
            <p><b>Latitude:</b> {selectedHospital.lat}</p>
            <p><b>Longitude:</b> {selectedHospital.lng}</p>
            <p><b>Address:</b> {selectedHospital.address}</p>
            <p><b>Contact:</b> {selectedHospital.contact}</p>
            <p><b>Capacity:</b> {selectedHospital.capacity}</p>
          </>
        )}
      </div>
    </div>
  );
}

export default App;
